






















import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useUserDelete from "@/hooks/useUserDelete";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import DeleteAccountView from "./components/DeleteAccountView.vue";

export default defineComponent({
  name: "PageDeleteAccount",
  components: { BaseIcon, DeleteAccountView, BasePage, BaseButton },
  setup(_, { root }) {
    const { authUser } = useAuthUser();
    const { restoreDate, restoreUser, deleteUser, restoreInterval } = useUserDelete();
    const showGoodBye = ref(false);
    const loading = ref(false);
    const userDeleteTimeoutId = ref<ReturnType<typeof setTimeout> | null>(null);

    const cleanTimeout = () => {
      userDeleteTimeoutId.value && clearTimeout(userDeleteTimeoutId.value);
      userDeleteTimeoutId.value = null;
    };

    const logout = () => {
      cleanTimeout();
      root.$router.push({ name: "logout" });
    };

    const onDeleteClick = async ({ password }: { password: string }, cb?: () => void) => {
      if (!authUser.value) return;
      try {
        loading.value = true;
        await deleteUser({ id: authUser.value.id, password });
        userDeleteTimeoutId.value = setTimeout(() => {
          logout();
        }, 10000);
        showGoodBye.value = true;
      } catch (e) {
        emitter.emit(EVENTS.STATUS_SHOW, { text: "Incorrect password" });
      } finally {
        cb && cb();
        loading.value = false;
      }
    };

    const handleRestore = async () => {
      try {
        loading.value = true;
        cleanTimeout();
        await restoreUser();
        root.$router.push({ name: "home", replace: true });
      } finally {
        loading.value = false;
      }
    };
    return {
      loading,
      showGoodBye,
      restoreDate,
      restoreInterval,
      onDeleteClick,
      handleRestore,
      logout,
    };
  },
});
